import React from 'react';
import { Container } from '@infoods/lifebase-ui';
import PropTypes from 'prop-types';

import { angularizeWithProviders } from '../../../../../shared/providers';
import { PageTitle } from '../../../../../shared/components/ui-components';
import { CustomerComplianceHistoryTable } from './CustomerComplianceHistoryTable/CustomerComplianceHistoryTable';
import { DataRangeFilter } from './DataRangeFilter/DataRangeFilter';
import { getRouteParam } from '../../../../../shared/utils/angularUtils';
import { useCustomerComplianceHistory } from '../../../../hooks/compliance-hooks';
import { ConsumptionBetweenWidget } from '../../../../components/consumption';
import { getFormattedDate } from '../../../../../shared/utils/dateUtils';
import { dateFormat } from '../../../../../shared/constants/apiDateFormat';

const NgzCustomerComplianceHistoryTab = ({
  customerFirstName,
  customerLastName,
  registrationDate,
}) => {
  const customerId = +getRouteParam('id');
  const customerRegistrationDate = getFormattedDate(
    registrationDate,
    dateFormat,
    'MM.DD.YYYY',
  );

  const { formMethods, complianceFields, consumptionFields } =
    useCustomerComplianceHistory({
      customerId,
      customerRegistrationDate,
      persistDatesInUrl: true,
    });
  const { control } = formMethods;

  const { consumptionInfo, isShowConsumptionWidget, toggleShowConsumptionWidget } =
    consumptionFields;

  return (
    <Container>
      <PageTitle title="Compliance">
        <DataRangeFilter
          control={control}
          isShowConsumptionWidget={isShowConsumptionWidget}
          toggleShowConsumptionWidget={toggleShowConsumptionWidget}
          customerRegistrationDate={customerRegistrationDate}
        />
      </PageTitle>
      <CustomerComplianceHistoryTable {...complianceFields} customerId={customerId} />
      {isShowConsumptionWidget && (
        <ConsumptionBetweenWidget
          consumptionInfo={consumptionInfo}
          firstName={customerFirstName}
          lastName={customerLastName}
          onClose={toggleShowConsumptionWidget}
        />
      )}
    </Container>
  );
};

NgzCustomerComplianceHistoryTab.propTypes = {
  customerFirstName: PropTypes.string,
  customerLastName: PropTypes.string,
  registrationDate: PropTypes.string,
};

angularizeWithProviders(
  NgzCustomerComplianceHistoryTab,
  'ngzCustomerComplianceHistoryTab',
  {
    customerFirstName: '<',
    customerLastName: '<',
    registrationDate: '<',
  },
);
